module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_1-90ae9ef402cd63f848adafef4a732eac.png";